import { useState } from "react";
import FormDealer from "./FormDealer";
import FormEmail from "./FormEmail";
import FormPopup from "./FormPopup";

import { BlobProvider } from "@react-pdf/renderer";
import PdfDocument from "../pdf/PdfDocument";

interface SummaryButtons {}

const SummaryButtons: React.FC<SummaryButtons> = () => {
  const [formPopup, setFormPopup] = useState(false);
  const [form, setForm] = useState("");
  const closePopup = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    setFormPopup(false);
    setForm("");
  };

  const EmailPopup = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    setFormPopup(true);
    setForm("email");
  };

  const DealerPopup = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    setFormPopup(true);
    setForm("dealer");
  };
  return (
    <BlobProvider document={<PdfDocument />}>
      {({ blob, url, loading }) => {
        const cleanUrl = url ? url : "#";
        return loading ? (
          <div>loading pdf...</div>
        ) : (
          <>
            <div className="summary-btns">
              <a className="summary-btn-left" onClick={EmailPopup}>
                Send to My Email
              </a>
              <a className="summary-btn-center" onClick={DealerPopup}>
                Send to Dealer
              </a>
              <a
                className="summary-btn-right"
                href={cleanUrl}
                download="myboat"
              >
                Download
              </a>
            </div>
            {formPopup && blob ? (
              <FormPopup isOpen={formPopup} onClose={closePopup}>
                {form === "email" ? (
                  <FormEmail blob={blob} />
                ) : (
                  <FormDealer blob={blob} />
                )}
              </FormPopup>
            ) : null}
          </>
        );
      }}
    </BlobProvider>
  );
};

export default SummaryButtons;
